export const reviewPath = (campaign_id) =>
  `/management_panel/campaign_library/${campaign_id}/edit?step=review`

export const achievementsPath = (campaign_id) =>
  `/management_panel/campaign_library/${campaign_id}/edit?step=achievements`
